export default __webpack_public_path__ + "static/media/logo_espol_interno.dd45abc2.svg";